module.exports = __webpack_public_path__ + "static/media/34-6.8c7f3784.mp3";